import React from 'react';
import { Card, CardText, CardHeader, RaisedButton } from 'material-ui';
import moment from 'moment';
import { StyleSheet, css } from 'aphrodite';

import DateRange from '../../DateRangeComponent';
import AdminReport from './AdminReport';

const DateFormat = 'DDMMM';

export default class AdminReportRenderer extends React.Component {
  constructor(props) {
    super(props);

    const defaultStart = moment().day(-6).startOf('day');
    const defaultEnd = moment().day(1).startOf('day');

    this.state = {
      startDate: defaultStart,
      endDate: defaultEnd,
      enteredStart: defaultStart,
      enteredEnd: defaultEnd,
    };
  }

  updateDates = (e) => {
    const { startDate, endDate } = e;
    this.setState({
      enteredStart: startDate,
      enteredEnd: endDate,
    });
  }

  setDates = () => {
    const { enteredStart, enteredEnd } = this.state;
    this.setState({
      startDate: enteredStart,
      endDate: enteredEnd,
    });
  }

  render() {
    const { startDate, endDate, enteredStart, enteredEnd } = this.state;
    const formattedStartDate = startDate.format(DateFormat).toUpperCase();
    const formattedEndDate = endDate.format(DateFormat).toUpperCase();
    const duration = moment.range(startDate, endDate).diff('days');
    const dateString = `${formattedStartDate}-${duration}NT`;

    return (<div><Card className={css(styles.report)}>
      <CardHeader title={`Admin Report for ${dateString}`} />
      <CardText className={css(styles.settings)}>
        <DateRange
          startValue={formattedStartDate}
          endValue={formattedEndDate}
          startLabel='Start Date'
          endLabel='End Date'
          onChange={this.updateDates}
          allowPast
        />
        <RaisedButton
          primary
          label='Set Dates'
          onTouchTap={this.setDates}
          disabled={startDate === enteredStart || endDate === enteredEnd}
        />
      </CardText>
    </Card>
      <AdminReport startDate={startDate} endDate={endDate} dateString={dateString} />
    </div>);
  }
}


const styles = StyleSheet.create({
  report: {
    margin: 15,
    minHeight: '100%',
  },
  settings: {
    display: 'flex',
    alignItems: 'baseline',
  },
});



// WEBPACK FOOTER //
// /src/components/Reports/Admin/AdminReportControls.js